import { forwardRef } from 'react'
import { InputBaseProps } from '@mui/material/InputBase'
import { IMaskInput } from 'react-imask'

export type InputBaseMaskProps = Pick<
  InputBaseProps,
  'className' | 'name' | 'onChange' | 'placeholder'
> & {
  // iMask props
  autofix?: boolean | 'pad'
  blocks?: { [key: string]: any }
  definitions?: any
  eager?: boolean
  format?: (value: Date) => string
  lazy?: boolean // set false to make placeholder always visible
  mask?: any
  max?: number
  min?: number
  overwrite?: boolean
  pattern?: string
  placeholderChar?: string
  scale?: number
  signed?: boolean
}

const InputBaseMask = forwardRef(function TextMaskCustom(props: InputBaseMaskProps, ref: any) {
  const {
    // iMask
    autofix,
    blocks,
    definitions,
    eager,
    format,
    lazy,
    mask,
    max,
    min,
    overwrite,
    pattern,
    placeholderChar,
    scale,
    signed,

    //
    className,
    onChange,
    placeholder,
    ...restProps
  } = props

  return (
    <IMaskInput
      {...restProps}
      // iMask
      autofix="pad"
      blocks={blocks}
      definitions={definitions}
      format={format}
      inputRef={ref}
      lazy={lazy}
      mask={mask || Number}
      min={min}
      max={max}
      pattern={pattern}
      placeholderChar={placeholderChar || '_'}
      onAccept={
        onChange
          ? (value: any, mask) => {
              const event = {
                target: { name: props.name || '', value }
              } as React.ChangeEvent<HTMLInputElement>
              onChange?.(event)
            }
          : undefined
      }
      overwrite={overwrite}
      radix="."
      scale={scale}
      signed={signed}
      eager={eager}
      // InputBase
      className={className}
      placeholder={placeholder}
    />
  )
})

export default InputBaseMask
